<template>
  <div>
    <Header />
    <div style="padding-left: 30px; padding-right: 30px; padding-bottom: 80px">
      <center v-if="loading">
        <br />
        <br />
        <Circle9 style="margin-bottom: 8px"></Circle9>
        <small>Cargando Datos ...</small>
        <br />
        <br />
      </center>
      <br />
      <el-row :gutter="20" v-if="!loading">
        <el-col :md="12">
          <h2>{{ $t("CREACIÓN DE CONTRATO - PASO 2") }}</h2>
        </el-col>
        <el-col :md="12">
          <StepsContrato v-bind:step="1"></StepsContrato>
        </el-col>
      </el-row>
      <!-- Workflow Salud -->
      <el-row :gutter="20" v-if="!loading">
        <el-col :md="6">
          <div>
            <h3>{{ $t("Flujo de revisión Riesgos de Salud") }}</h3>
            <el-select
              :disabled="true"
              v-model="selectedWorkflows.salud"
              @change="setAuxSelectedWorkflows('salud')"
              filterable
              :placeholder="$t('Seleccione un flujo de revisión')"
              class="w-90"
            >
              <el-option
                v-for="workflow in workflows"
                :label="workflow.name"
                :value="workflow._id"
                :key="workflow._id"
              />
            </el-select>
          </div>
        </el-col>

        <el-col
          v-if="auxSelectedWorkflows.salud"
          :md="18"
          class="worflow-preview"
        >
          <h3>
            {{ $t("Previsualización") }} "{{ auxSelectedWorkflows.salud.name }}"
          </h3>
          <Workflow :workflow="auxSelectedWorkflows.salud"></Workflow>
        </el-col>
      </el-row>

      <hr class="separator" v-if="!loading" />

      <!-- Workflow Seguridad -->
      <el-row :gutter="20" v-if="!loading">
        <el-col :md="6">
          <div>
            <h3>{{ $t("Flujo de revisión Riesgos de Seguridad") }}</h3>
            <el-select
              :disabled="true"
              v-model="selectedWorkflows.seguridad"
              @change="setAuxSelectedWorkflows('seguridad')"
              filterable
              :placeholder="$t('Seleccione un flujo de revisión')"
              class="w-90"
            >
              <el-option
                v-for="workflow in workflows"
                :label="workflow.name"
                :value="workflow._id"
                :key="workflow._id"
              />
            </el-select>
          </div>
        </el-col>

        <el-col
          v-if="auxSelectedWorkflows.seguridad"
          :md="18"
          class="worflow-preview"
        >
          <h3>
            {{ $t("Previsualización") }} "{{
              auxSelectedWorkflows.seguridad.name
            }}"
          </h3>
          <Workflow :workflow="auxSelectedWorkflows.seguridad"></Workflow>
        </el-col>
      </el-row>

      <hr class="separator" v-if="!loading" />

      <!-- Workflow Salud -->
      <el-row :gutter="20" v-if="!loading">
        <el-col :md="6">
          <div>
            <h3>{{ $t("Flujo de revisión Riesgos de Medioambiente") }}</h3>
            <el-select
              :disabled="true"
              v-model="selectedWorkflows.medioambiente"
              @change="setAuxSelectedWorkflows('medioambiente')"
              filterable
              :placeholder="$t('Seleccione un flujo de revisión')"
              class="w-90"
            >
              <el-option
                v-for="workflow in workflows"
                :label="workflow.name"
                :value="workflow._id"
                :key="workflow._id"
              />
            </el-select>
          </div>
        </el-col>

        <el-col
          v-if="auxSelectedWorkflows.medioambiente"
          :md="18"
          class="worflow-preview"
        >
          <h3>
            {{ $t("Previsualización") }} "{{
              auxSelectedWorkflows.medioambiente.name
            }}"
          </h3>
          <Workflow :workflow="auxSelectedWorkflows.medioambiente"></Workflow>
        </el-col>
      </el-row>

      <hr class="separator" v-if="!loading" />

      <el-col :span="24" class="centrar">
        <el-button-group>
          <el-button
            type="primary"
            @click="backStep()"
            icon="el-icon-arrow-left"
            >Regresar</el-button
          >
          <el-button @click="nextStep()" type="primary">
            {{ $t("Siguiente") }}
            <i class="el-icon-arrow-right el-icon-right"></i>
          </el-button>
        </el-button-group>
      </el-col>
      <br />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import StepsContrato from "@/components/contracts/StepsContrato.vue";
import Workflow from "@/components/workflows/Workflow2.vue";
import { Circle9 } from "vue-loading-spinner";
import Header from "../components/Header.vue";

export default {
  name: "wizard",
  components: {
    StepsContrato,
    Workflow,
    Circle9,
    Header,
  },
  data() {
    return {
      loading: false,
      selectedWorkflows: {
        salud: "",
        seguridad: "",
        medioambiente: "",
      },
      auxSelectedWorkflows: {
        salud: "",
        seguridad: "",
        medioambiente: "",
      },
      workflows: [],
    };
  },
  async created() {
    if (Object.keys(this.$store.getters.newContract).length === 0) {
      this.$router.push({ name: "autoCreacionStep1" });
    }
    await this.getWorkflows();
    this.newContract.workflows = {};
    if (this.newContract.tipo_contrato === "Propio") {
      this.newContract.workflows.salud = "5cf05dceb1e89e78a811d38d";
      this.newContract.workflows.seguridad = "5cf05deeb1e89e78a811d38e";
      this.newContract.workflows.medioambiente = "5cf05e08b1e89e78a811d38f";
    }
    if (this.newContract.tipo_contrato === "Contratista") {
      this.newContract.workflows.salud = "5b5783d3ff7564001188afb0";
      this.newContract.workflows.seguridad = "5d4464250509f644aa7ff6fd";
      this.newContract.workflows.medioambiente = "5d44642c0509f644aa7ff6fe";
    }
    this.selectedWorkflows.salud = this.newContract.workflows.salud;
    this.selectedWorkflows.seguridad = this.newContract.workflows.seguridad;
    this.selectedWorkflows.medioambiente =
      this.newContract.workflows.medioambiente;
    this.setAuxSelectedWorkflows("salud");
    this.setAuxSelectedWorkflows("seguridad");
    this.setAuxSelectedWorkflows("medioambiente");
  },
  computed: {
    ...mapGetters({
      newContract: "newContract",
    }),
  },
  methods: {
    ...mapActions(["setNewContract"]),
    backStep() {
      this.$router.push({ name: "autoCreacionStep1" });
    },
    async getWorkflows() {
      this.loading = true;
      let response = await axios.get(`/data-science/workflows`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      this.workflows = response.data;
      this.loading = false;
    },
    async nextStep() {
      this.loading = true;
      const valid = this.workflowsValidation();
      if (valid) {
        const auxContract = Object.assign({}, this.newContract, {
          workflows: this.selectedWorkflows,
        });
        this.setNewContract(auxContract);
        this.$router.push({ name: "autoCreacionStep3" });
      } else {
        this.$message({
          message:
            "Atención, Para continuar debes seleccionar un flujo de aprobación para cada tipo.",
          type: "warning",
        });
        this.loading = false;
      }
    },
    workflowsValidation() {
      if (
        this.selectedWorkflows.salud &&
        this.selectedWorkflows.seguridad &&
        this.selectedWorkflows.medioambiente
      ) {
        return true;
      }
      return false;
    },
    setAuxSelectedWorkflows(type) {
      this.auxSelectedWorkflows[type] = this.workflows.find(
        (e) => e._id === this.selectedWorkflows[type]
      );
    },
  },
};
</script>

<style scoped>
.separator {
  margin: 40px 0;
}
.worflow-preview {
  border-left: solid 1px;
  padding-left: 20px;
}
.titleProfilesArea {
  color: #606266;
  font-size: 14px;
}
.textProfilesArea {
  margin-top: 10px;
  color: gray;
  font-size: 14px;
}
.centrar {
  text-align: center;
}
</style>
